import React, { useState, useEffect, useContext} from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import SocialMediaLinks from '../../common/SocialLinks/SocialLinks';
import '../../App.css';
import { BASE_URL } from '../../baseUrl'

import { Stack } from '@mui/material';
import AccountPopover from '../../common/account-popover';
import { UserContext } from '../../context/UserContext';

const Header = () => {
 
  const location = useLocation();
 
//const [token, setToken] = useContext(UserContext);
const [login, setLogin] = useContext(UserContext);
const isLoggedIn = login.isLoggedIn;
const [UserBio, setUserBio] = useState({});

const navigate = useNavigate();

const handleLogout = () => {
  //setToken(null);
  setLogin({ token: null, isLoggedIn: false });
  setUserBio(""); //Clear user data
  // Clear local storage
  localStorage.removeItem('tkn_2050');

  // Navigate back to home page or login page
  navigate('/');

};

const fetchUserData = () => {
  // Fetch user data and update UserBio state
  // Hey David let's see if the code is updated - 04/12/2024
  // console.log('----')
  // console.log(login.token)
  fetch(BASE_URL+"/api/user/profile", {
    headers: {
      //Authorization: `Bearer ${localStorage.getItem('tkn_2050')}`, // Include the token in the headers
      Authorization: `Bearer ${login.token}`, // Include the token in the headers
    
    },
  })
  .then(response => response.json())
  .then(data => {
    setUserBio(data.user);
  })
  .catch(error => console.error("Error fetching user data:", error));
};


// Call the fetchUserData function when the component mounts or when the user logs in
useEffect(() => {
  if (isLoggedIn) {
    fetchUserData();
  }
}, [isLoggedIn]);



  useEffect(() => {
    const sectionId = location.hash.slice(1);
    if (sectionId) {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const renderSection = () => {
    const validPaths = ['/', '/scatter', '/barchart', '/login', '/sign-up', '/UserProfile', '/Scatter_Edit','/Strategies', '/Barchart', '/ScatterPBI', '/Strategies/MyStrategiesPage'];
    
    if (validPaths.includes(location.pathname)) {
      return (
        <nav className="navbar">
          <Link to="/#home">Home</Link>
          <Link to="/#about">About us</Link>
          <Link to="/#tool">Our tool</Link>
          <Link to="/#CNC">Cities & Communities</Link>
          <Link to="/#network">Network</Link>
          <Link to="/#contact">Contact us</Link>
        </nav>
      );
    }
  
    return null;
  };

  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerClassName = isHeaderActive ? 'header active' : 'header';

  function handleMenuClick() {
    setIsMenuOpen(!isMenuOpen);
    setIsHeaderActive(!isMenuOpen);
  }

  return (
    <header className={headerClassName}>
      <div className="menu-bars" onClick={handleMenuClick}>
      <div className="login-SUP">
 

</div>
      
      <div className='account-popover-container'>
        
          <Stack direction="row" alignItems="center" spacing={1}>
            <AccountPopover />
          </Stack>
        
      </div>

        <div
          id="menu-bars"
          className={`fas fa-bars ${isMenuOpen ? 'fas fa-chevron-left' : ''}`}
        ></div>





      </div>

      <Link to="/" className="logo">
        <span>PLANNING</span> DASHBOARD
      </Link>

      {renderSection()}

      <div className="follow">
        <SocialMediaLinks />
      </div>

      {isMenuOpen && <nav className="navbar open"></nav>}


      <div className="follow"></div>
    </header>
  );
};

export default Header;
